/* global angular */
( function () {
	'use strict';

	function templateView () {
		var obj = {
			'viewOnly' : true
		};

		function setView ( flag ) {
			obj.viewOnly = flag;
		}

		function getView () {
			return obj.viewOnly;
		}

		return {
			'setViewOnly' : setView,
			'get'         : getView
		};
	}

	angular
		.module( 'app.templates' )
		.factory( 'templateView', templateView );
} )();
